import { POLL_MEDICAL_RECORDS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    refresh_available?: boolean;
}

export default (ptId: string, sourceRefreshedAt?: number): Promise<Response> => {
    return fetchWithRefresh(POLL_MEDICAL_RECORDS(ptId, sourceRefreshedAt)).then((res) =>
        res.json(),
    );
};
